import DiscussBar from './DiscussBar'
import DiscussBarContianer from './DiscussBarContainer'

export default DiscussBarContianer(DiscussBar)
